import React, { useEffect, useState } from 'react'
import cameraIcon from "../../assets/svg/CameraIcon.svg";
import axios from 'axios';
import { newHost } from "../../pages/Categories/CategoryProfile";
import { newImageUrl } from "../../pages/Manufacturers/ManufactureProfile";import { useLocation, useNavigate, useParams } from 'react-router';
import { toast } from 'react-toastify';
import defaultImage from "../../assets/svg/defultImage.svg";
import { Modal } from 'react-bootstrap';
const ImageBefore = () => {
  const token = localStorage.getItem("token");
  const { id: orderId } = useParams()

  const [configs, setConfigs] = useState([])
  const [imagesBefore, setImagesBefore] = useState([])
  const [imagePreview, setImagePreview] = useState({})
  const [uploadedImagesBefore, setUploadedImagesBefore] = useState([])
  const [loadingImagesBefore, setLoadingImagesBefore] = useState(true);
  const [order, setOrder] = useState(null);

  const FileChange = (e, configId) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onloadend = () => {
      setImagePreview(prev => ({
        ...prev,
        [configId]: reader.result
      }));

      setUploadedImagesBefore(prev => ({
        ...prev,
        [configId]: file
      }));
    };

    reader.readAsDataURL(file);
  };
 
  const getImagesConfig = async () => {
    try {
      const response = await axios.get(`${newHost}stuff/get-configs`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      setConfigs(response.data.data?.configs)
    } catch (error) {
      console.log(error.response);

    }
  }
  const getImagesBefore = async () => {
  try {
    const response = await axios.get(`${newHost}stuff/get-before-images/${orderId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    setImagesBefore(response.data.data?.images_before || []);
  } catch (error) {
    console.log(error.response);
  } finally {
    setLoadingImagesBefore(false);
  }
};
    const getOrders = async () => {
             try {
               const response = await axios.get(`${newHost}stuff/get-order-products/${orderId}`, {
                 headers: { Authorization: `Bearer ${token}` },
               });
         const order = response.data.data?.data; 
       
              
          setOrder(order)
         
             } 
             catch (error) {
               console.log(error);
             } 
           }; 

  useEffect(() => {
    getImagesConfig()
    getImagesBefore()
    getOrders()
  }, [])


  const location = useLocation()

 const startOrderExecution = async () => {
  try {
    const response = await axios.get(`${newHost}stuff/start-execution/${orderId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    toast.success(response.data.message);
     navigte(`/ordersExecution/checkItems/${orderId}`, {
  });

  } catch (error) {
    console.log(error.response);
    toast.error(error.response?.data?.errors?.message);
  }
};
const handleSubmit = async () => {

  const formData = new FormData();

  let index = 0; 

  configs.forEach((config) => {

    const file = uploadedImagesBefore[config.id];

    if (file) {
      formData.append(`configs[${index}][id]`, config.id);

      formData.append(
        `configs[${index}][before_image]`,
        file
      );

      index++; 
    }

  });

  try {
    const response = await axios.post(
      `${newHost}stuff/upload-before-images/${orderId}`,
      formData,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    toast.success(response.data?.message);
    getImagesBefore()
  } catch (error) {
    toast.error(error.response.data.errors?.message);
  }

}; 

  const navigte = useNavigate()
 
  const uploadedCount = Object.keys(uploadedImagesBefore).length;
  const totalConfigs = configs.length;

  

  return (
    <>
      
    <div className="m-4" dir="rtl">
         <div className="my-2">
{                loadingImagesBefore && <div className="text-center my-5">Loading...</div> 
}
              {imagesBefore.length > 0 ?
                <>

                  <div className="">
                    <h6 className="main-text-color">
                      صور خاصة بالسيارة قبل تنفيذ الخدمات
                    </h6>
                    <div className="row my-2 min-vh-100">

                      {imagesBefore.map((img) => (
                        <div key={img.id} className="col-md-2 col-12">
                          <label
                            htmlFor={`profile_photo_${img.id}`}
                            className="w-100 my-2 text-center"
                          >
                            {img?.config?.label_ar}
                     

                            <div
                              style={{
                                width: "100%",
                                height: "120px",
                                cursor: "pointer",
                                borderRadius: "15px"
                              }}
                            >
                              <img
                                src={img.image_url ? `${newImageUrl}${img?.image_url}` : defaultImage}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "fill",
                                  borderRadius: "15px"
                                }}
                              />
                            </div>

                        

                          </label>


                        </div>
                      ))}
                    </div>

                  </div>
                  <div className={`d-flex justify-content-center fixed-footer ${order?.status !== "arrived_at_location"? "d-none" : ""}`}>
                <button
                        onClick={startOrderExecution}
                  
                        className="btn btn-dark px-5 d-flex gap-1"
                        style={{
                          cursor:  "pointer"
                        }}
                      >
                           تنفيذ الطلب
                      </button>
                  </div>
                </>
                :
                <>
                  <div className="">
                    <h6 className="main-text-color">
                      اضافة صور خاصة بالسيارة قبل تنفيذ الخدمات
                    </h6>
                    <div className="row my-2">

                      {configs.map((config) => (
                        <div key={config.id} className="col-md-2 col-12">
                          <label
                            htmlFor={`profile_photo_${config.id}`}
                            className="w-100 my-2 text-center"
                          >
                            {config?.label_ar}
                            <input
                              type="file"
                              id={`profile_photo_${config.id}`}
                              className="d-none"
                              onChange={(e) => FileChange(e, config.id)}
                            />

                            {imagePreview[config.id] ? (

                              <div
                                style={{
                                  width: "100%",
                                  height: "120px",
                                  cursor: "pointer",
                                  borderRadius: "15px"
                                }}
                              >
                                <img
                                  src={imagePreview[config.id]}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "fill",
                                    borderRadius: "15px"
                                  }}
                                />
                              </div>

                            ) : (

                              <div
                                style={{
                                  border: "dashed 1px #C6C6C6",
                                  width: "100%",
                                  height: "120px",
                                  cursor: "pointer",
                                  borderRadius: "15px"
                                }}
                                className="d-flex flex-column justify-content-center align-items-center my-1 p-2"
                              >

                                <img src={cameraIcon} style={{ width: "40px" }} />
                                <p className="main-text-color label-size m-0">Add Image</p>

                              </div>

                            )
                            }

                          </label>


                        </div>
                      ))}
                    </div>
                    <div className="d-flex justify-content-center fixed-footer">
                      <button
                        onClick={handleSubmit}
                        className="btn btn-dark px-5 d-flex gap-1"
                        style={{
                          cursor:  "pointer"
                        }}
                      >
                        {`حفظ ${uploadedCount} من ${totalConfigs}`}

                      </button>
                    </div>
                  </div>



                </>}


            </div>
    </div>
    </>
  )
}

export default ImageBefore